export const addonSum = (addons = []) => addons.reduce((s, a) => s + a.price, 0);
export const lineTotal = (it) => (it.price + addonSum(it.addons)) * it.qty;
export const cartKey = (itemId, addons = []) => (addons.length ? `${itemId}:${addons.map((a) => a.id).sort().join(",")}` : itemId);
